module.exports = __webpack_public_path__ + "images/people/man-woman-employees@2x-c7342b148be68ea83d3886156b55ae75.webp";